import { render, staticRenderFns } from "./delivery-cdlsuite.vue?vue&type=template&id=d5c9e58c"
import script from "./delivery-cdlsuite.vue?vue&type=script&lang=js"
export * from "./delivery-cdlsuite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports